export const LANGUAGE_COOKIE_NAME = "locale";
export const FALLBACK_LANGUAGE = "ar";

export const MEDIA_BREAKPOINT_SM = 576;
export const MEDIA_BREAKPOINT_MD = 768;
export const MEDIA_BREAKPOINT_LG = 992;
export const MEDIA_BREAKPOINT_XL = 1200;
export const MEDIA_BREAKPOINT_XXL = 1300;
export const SUBSCRIPTION_STATUS_ACTIVE = "active";
export const SUBSCRIPTION_STATUS_TRIALING = "trialing";
export const SUBSCRIPTION_STATUS_PAST_DUE = "past_due";
export const SUBSCRIPTION_STATUS_CANCELLED = "cancelled";
export const SUBSCRIPTION_STATUS_EXPIRED = "expired";
